import { motion } from "framer-motion";
import { Logo } from "@/components/Logo";

export const Loader = () => (
  <motion.div
    data-testid="site-loader"
    className="fixed inset-0 z-[100] bg-ink flex flex-col items-center justify-center gap-8"
    exit={{ opacity: 0, transition: { duration: 0.7, ease: "easeInOut" } }}
  >
    <motion.div
      initial={{ opacity: 0, scale: 0.85 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      className="relative"
    >
      <motion.span
        className="absolute -inset-4 rounded-full border border-gold/40"
        animate={{ scale: [1, 1.15, 1], opacity: [0.6, 0.15, 0.6] }}
        transition={{ duration: 1.8, repeat: Infinity, ease: "easeInOut" }}
      />
      <Logo size="xl" testId="loader-logo" />
    </motion.div>
    <div className="w-48 h-px bg-white/10 overflow-hidden">
      <motion.div
        className="h-full bg-gradient-to-r from-gold to-champagne"
        initial={{ width: "0%" }}
        animate={{ width: "100%" }}
        transition={{ duration: 1.5, ease: "easeInOut" }}
      />
    </div>
    <p className="font-accent text-[10px] uppercase tracking-[0.4em] text-zinc-500">B&amp;H Truck Dispatching</p>
  </motion.div>
);
